


























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { boldSearchKeywords } from '@/utils/search.util';
import {
  GetRolesQueryParams,
  RoleSansTree
} from '@/store/modules/role/types/role.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { Group, User } from '@/store/modules/admin/types/admin.types';

@Component({
  components: { BaseLoading }
})
export default class SelectRoleComponent extends Vue {
  $refs!: {
    selectRoleDropdown: any;
  };

  @Prop({ default: null }) public selected!: RoleSansTree[] | null;
  @Prop() public selectedUser!: User | null;
  @Prop() public selectedGroup!: Group | null;

  public selectedRole: RoleSansTree[] | null = this.selected || null;
  public searchInput: string = '';
  public isLoading: boolean = false;

  @Action('role/getRoles')
  private getRolesAction!: (params: GetRolesQueryParams) => Promise<void>;

  @State(({ role }: RootState) => role.roles?.items)
  private roles!: RoleSansTree[];

  @State(({ role }: RootState) => role.apiState.getRoles)
  private getRolesState!: ApiState;

  get rolesList(): RoleSansTree[] {
    return this.roles || [];
  }

  /** Opens dropdown only if no role selected */
  public toggleDropdown() {
    if (!this.selectedRole && !this.$refs.selectRoleDropdown.isActive) {
      this.$refs.selectRoleDropdown.toggle();
    }
  }

  public clearInput(): void {
    this.searchInput = '';
  }
  public checkCondition(): boolean {
    return !!(this.selectedGroup || this.selectedUser);
  }

  public clearSelection(): void {
    this.selectedRole = [];
    this.$emit('selectedRole', []);
  }

  public handleRemoveItem(item: RoleSansTree): void {
    if (this.selectedRole) {
      const dataIndex = this.selectedRole.findIndex(
        (selectedItem) => selectedItem.name === item.name
      );
      this.selectedRole.splice(dataIndex, 1);
      this.$emit('selectedUser', this.selectedRole);
    }
  }

  public onInputFocus(): void {
    this.getRoleList();
  }

  public mounted(): void {
    this.getRoleList();
  }

  /** Calls existing getRoles action */
  public getRoleList(): void {
    this.getRolesAction({
      limit: 50,
      page: 1,
      searchQuery: this.searchInput,
      sortOrder: 'ASC',
      sortColumn: 'name'
    });
  }

  public highlightedLabel(role: RoleSansTree): string {
    return boldSearchKeywords(role.name, this.searchInput);
  }

  @Debounce(400)
  @Watch('searchInput')
  public onSearch(value: string): void {
    this.searchInput = value;
    this.getRoleList();
  }

  @Watch('selectedRole')
  public onSelectRole() {
    this.$emit(
      'selectedRole',
      this.selectedRole?.length ? this.selectedRole : [this.selectedRole]
    );
  }

  @Watch('getRolesState')
  public onGetRolesState(state: ApiState): void {
    this.isLoading = state.loading;
  }
}
